import { render, staticRenderFns } from "./Metarecebimento.vue?vue&type=template&id=a13a9c0c&"
import script from "./Metarecebimento.vue?vue&type=script&lang=js&"
export * from "./Metarecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports